
































import { defineComponent, computed } from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';

import getDataForGroupAddress from '@/gql/getDataForGroupAddress.gql';

import CommonProvinceSelector from '@/components/Selector/CommonProvinceSelector.vue';
import CommonAmphurSelector from '@/components/Selector/CommonAmphurSelector.vue';
import CommonDistrictSelector from '@/components/Selector/CommonDistrictSelector.vue';

const GroupAddressEditor = defineComponent({
  setup(props: any, context: any) {
    const getDataForGroupAddressQuery = useQuery(getDataForGroupAddress);
    const provinces = useResult(getDataForGroupAddressQuery.result, [], (data: any) => data.thailandProvinces);

    const amphurs = computed(() => {
      if (!props.value.province) return [];
      const filteredProvince = provinces.value.find((province: any) => String(province.id) === String(props.value.province.id));
      if (filteredProvince && filteredProvince.amphurs) return filteredProvince.amphurs;
      return [];
    });

    const districts = computed(() => {
      if (!props.value.amphur) return [];
      const filteredAmphur = amphurs.value.find((amphur: any) => String(amphur.id) === String(props.value.amphur.id));
      if (filteredAmphur && filteredAmphur.districts) return filteredAmphur.districts;
      return [];
    });

    function onUpdate(type: string, newValue: string | number) {
      if (type === 'province') {
        context.emit('input', {
          ...props.value,
          province: { id: newValue },
          amphur: { id: null },
          district: { id: null },
        });
      } else if (type === 'amphur') {
        context.emit('input', {
          ...props.value,
          amphur: { id: newValue },
          district: { id: null },
        });
      } else if (type === 'district') {
        context.emit('input', {
          ...props.value,
          district: { id: newValue },
        });
      } else if (type === 'postcode') {
        context.emit('input', {
          ...props.value,
          postcode: newValue,
        });
      } else if (type === 'address') {
        context.emit('input', {
          ...props.value,
          address: newValue,
        });
      } else {
        context.emit('input', {
          province: null,
          amphur: null,
          district: null,
          address: '',
          postcode: '',
        });
      }
    }

    return {
      amphurs,
      districts,
      onUpdate,
    };
  },
  props: {
    value: {}, // address object
  },
  components: {
    CommonProvinceSelector,
    CommonAmphurSelector,
    CommonDistrictSelector,
  },
});

export default GroupAddressEditor;
